export default __webpack_public_path__ + "fcc89399ef5ee78ef9aaf7714b5c6ba2.svg";